function fn_comp_school() {
    var $fn = $(".comp_school");

    if($fn.length){
        $fn.on("click","[data-gallery]",function (e) {
            e.preventDefault();

            var $this = $(this),
                $gallery_data = $this.data("gallery");

            $this.lightGallery({
                dynamic: true,
                thumbnails: true,
                counter: true,
                download: true,
                closable: true,
                selector: ".elm_image",
                dynamicEl: $gallery_data
            });
        });

        $fn.on("click","[data-toggle]",function (e) {
            e.preventDefault();
            var $this = $(this);

            $this.toggleClass("mod--active").prev(".elm_text").toggleClass("mod--active");
        })
    }
}